export default __webpack_public_path__ + "static/media/messenger_logo.2f40e79c.png";